import firebase from './'

export const fireCallFN = async (name: string, params?: any) => {
  const initialiseFN = firebase.functions().httpsCallable(name)
  return await initialiseFN(params)
}
